//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from "vuex";
import Card from "@/components/common/card.comp.vue";
export default {
  name: "Search",
  data() {
    return {
      details: true
    };
  },
  computed: {
    ...mapGetters(["searchedShows"])
  },
  components: {
    Card
  }
};
